/**
 * Patient Narrative wizard sections.
 *
 * Distinct from `WIZARD_SECTIONS` (wizardSections.js) - Patient Narrative is
 * a standalone product with its own backend model and section vocabulary,
 * not a CSR study. Every wizard page owns exactly one section:
 *
 *   GET   /patient-narratives/{id}/wizards/{section}
 *     -> { sectionData: {...} }  exactly what was last saved ({} if never)
 *   PATCH /patient-narratives/{id}/wizards/{section}
 *     <- the whole page state (full replacement); same response as GET
 *
 * Answers are keyed by the question aliases (`qParticipantTerm`, ...) served
 * by GET /patient-narratives/questions, plus two non-question keys in
 * patient_scope: `other_events` and `subject_identifier_confirmed`.
 */
export const PATIENT_NARRATIVE_WIZARD_SECTIONS = {
  projectConventions: "project_conventions",
  patientScope: "patient_scope",
  sources: "sources",
  narrativeFormat: "narrative_format",
};

export const PATIENT_NARRATIVE_WIZARD_SECTION_TITLES = {
  [PATIENT_NARRATIVE_WIZARD_SECTIONS.projectConventions]:
    "Project & Conventions",
  [PATIENT_NARRATIVE_WIZARD_SECTIONS.patientScope]: "Patient Scope",
  [PATIENT_NARRATIVE_WIZARD_SECTIONS.sources]: "Sources",
  [PATIENT_NARRATIVE_WIZARD_SECTIONS.narrativeFormat]: "Narrative Format",
};
